﻿// Import of creatApp from Vue 3 bundler and axius for API requests.
import { createApp } from 'vue/dist/vue.esm-bundler';

const axios = require('axios');

import { tns } from 'tiny-slider/src/tiny-slider.js';

document.addEventListener('DOMContentLoaded', () => {
    const $newsWidgets = document.querySelectorAll('.widget-news');
    if ($newsWidgets.length) {
        var appArray = [];
    }
    $newsWidgets.forEach(function ($newsWidget, index) {
        appArray[index] = createApp({
            data() {
                return {
                    dataApi: '',
                    dataLimit: 10, // Default limit in BE
                    parentId: '',
                    overrule: [],
                    dataSortKey: '',
                    dataSortDirection: '',
                    dataAmountsSentence: '',
                    parentId: '',
                    loading: true,
                    data: null,
                    filters: [],
                    query: {}
                }
            },
            computed: {
                orderItems() {
                    if (!this.dataSortKey && !this.dataSortDirection) return [];
                    return [
                        {
                            Key: this.dataSortKey,
                            Direction: this.dataSortDirection,
                        }
                    ]
                },
                filterItems() {
                    let parentID = this.parentId;
                    let overrule = this.overrule;
                    if (overrule.length) {
                        return [
                            { Key: 'parentId.keyword', Values: [parentID], Operator: 'In' },
                            { Key: 'id.keyword', Values: overrule, Operator: 'In' }
                        ];
                    } else {
                        return [
                            { Key: 'parentId.keyword', Values: [parentID], Operator: 'In' }
                        ]
                    }
                    
                },
                queryModel() {
                    return {
                        Limit: this.dataLimit,
                        OrderItems: this.orderItems,
                        FilterItems: this.filters
                    }
                },
            },
            methods: {
                // The fetchData method fetches and handles API data, mainly facets and resulting items. 
                // The parameters ensure the method can be called in different ways.
                fetchData(initial = false) {
                    axios
                        .post(this.dataApi, this.query)
                        .then(response => {
                            if (response.status === 200) {
                                if (initial) {
                                    this.data = response.data;
                                    if (this.overrule.length) {
                                        this.filters = [
                                            { Key: 'parentId.keyword', Values: [this.parentId], Operator: 'In' },
                                            { Key: 'id.keyword', Values: this.overrule, Operator: 'NotEq' }
                                        ];
                                        this.query = {
                                            Limit: parseInt(this.dataLimit) - this.overrule.length,
                                            OrderItems: this.orderItems,
                                            FilterItems: this.filters
                                        };
                                        this.fetchData(false);
                                    } else {
                                        this.loading = false;
                                    }
                                } else {
                                    response.data.items.forEach(item => this.data.items.push(item));
                                    this.loading = false;
                                }
                            }
                        })
                        .catch(error => console.log(error))
                },
                toMediaQuery(mediaString) {
                    if (!mediaString) return '';
                    return mediaString.split('"')[1];
                },
                reverse(array) {
                    return [...array].reverse();
                }
            },
            updated() {
                if (this.data.items && this.data.items.length && !this.loading) {
                    tns({
                        container: this.$el.querySelectorAll('.slider-list')[0],
                        speed: 500,
                        items: 1,
                        slideBy: 1,
                        center: true,
                        gutter: 20,
                        prevButton: this.$el.querySelectorAll('.tns-button-prev')[0],
                        nextButton: this.$el.querySelectorAll('.tns-button-next')[0],
                        mouseDrag: true,
                        nav: false,
                        responsive: {
                            768: {
                                items: 2,
                                center: false,
                            },
                            1024: {
                                items: 3,
                                center: false
                            }
                        },
                        onInit: (ts) => {
                            ts.nextButton.setAttribute('tabindex', 0);
                            ts.prevButton.setAttribute('tabindex', 0);
                        }
                    });
                }
            },
            mounted() {
                // Set data props according to data attributes in HTML template.
                if (this.$el.dataset.api) this.dataApi = this.$el.dataset.api;
                if (this.$el.dataset.parentid) this.parentId = this.$el.dataset.parentid;
                if (this.$el.dataset.overrule) this.overrule = this.$el.dataset.overrule.split(',');
                if (this.$el.dataset.limit) this.dataLimit = parseInt(this.$el.dataset.limit);
                if (this.$el.dataset.sortkey) this.dataSortKey = this.$el.dataset.sortkey;
                if (this.$el.dataset.sortdirection) this.dataSortDirection = this.$el.dataset.sortdirection;
                this.filters = this.filterItems;
                this.query = this.queryModel;
                if (this.overrule.length) {
                    this.query =
                    {
                        Limit: this.dataLimit,
                        OrderItems: '',
                        FilterItems: this.filters
                    }
                }
                this.fetchData(true);
            }
        });
        appArray[index].mount($newsWidget);
    });
});